import React, { useState } from 'react';
import useCheckAccess from 'hooks/useCheckAccess';
import { useRecordContext, useNotify, useRefresh } from 'react-admin';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import useDialog from 'hooks/useDialog';
import create from 'utils/api/create';

const RefreshBackgroundCheck = () => {
  const record = useRecordContext();
  const checkAccess = useCheckAccess();
  const { open, openDialog, closeDialog } = useDialog();
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  if (!checkAccess('actions', 'UniversalBackgroundCheck', 'submit')) {
    return null;
  }

  if (!record?.background_check_pqs?.[0]?.professional_qualification_attributes?.[0]?.value) {
    return null;
  }

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await create(
        `v3/admin/professionals/${record.id}/refresh_background_check`,
        {},
        'Professional',
      );
      notify(response?.data?.message ?? 'Background check refresh initiated', { type: 'success' });
    } catch (error) {
      notify(error?.message ?? 'Error refreshing background check', { type: 'error' });
    } finally {
      setIsLoading(false);
      closeDialog();
      refresh();
    }
  };

  return (
    <>
      <Button onClick={openDialog}>Refresh background check</Button>
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>Confirm Background Check Refresh</DialogTitle>
        <DialogActions>
          <Button disabled={isLoading} onClick={closeDialog}>
            Cancel
          </Button>
          <Button disabled={isLoading} onClick={handleSubmit} color="primary" variant="contained">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RefreshBackgroundCheck;
